module.exports = __webpack_public_path__ + "static/media/Group3.4acba528.png";